"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _iconify = require("@iconify/react/dist/iconify.js");
var _material = require("@mui/material");
var _Modal = _interopRequireDefault(require("@mui/material/Modal"));
var _DocumentGrid = require("../../../../pages/DocumentManagementView/DocumentGrid.utils");
var _Alerts = require("../../Alerts/Alerts");
var _CreateFolderStep = _interopRequireDefault(require("../UploadFile/CreateFolderStep"));
var _axios = _interopRequireDefault(require("@/configs/axios"));
var _constants = require("@/util/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var EditModal = exports.EditModal = function EditModal(_ref) {
  var _currentFile$metadata2;
  var callbackClose = _ref.callbackClose,
    file = _ref.file,
    documents = _ref.documents,
    selectedPath = _ref.selectedPath;
  var tree = (0, _DocumentGrid.getBlobTree)(documents !== null && documents !== void 0 ? documents : []);
  var type = file.fileType === _constants.TYPE_FOLDER ? "folder" : "file";
  var _useState = (0, _react.useState)(file),
    _useState2 = _slicedToArray(_useState, 2),
    currentFile = _useState2[0],
    setCurrentFile = _useState2[1];
  var _useState3 = (0, _react.useState)(_constants.AlertColor.Info),
    _useState4 = _slicedToArray(_useState3, 2),
    alertColor = _useState4[0],
    setAlertColor = _useState4[1];
  var _useState5 = (0, _react.useState)(""),
    _useState6 = _slicedToArray(_useState5, 2),
    alertMessage = _useState6[0],
    setAlertMessage = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isLoading = _useState8[0],
    setIsLoading = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isDisabled = _useState0[0],
    setIsDisabled = _useState0[1];
  var editDocument = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var attributes, _currentFile$metadata, url, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsLoading(true);
            attributes = {};
            if (file.fileType !== _constants.TYPE_FOLDER) {
              // FileAlias is from Knowledge base, if not is Teams files
              attributes[currentFile.fileAlias || currentFile.uuid + "-" + currentFile.documentName] = {
                category: currentFile.category,
                metadata: (_currentFile$metadata = currentFile.metadata) !== null && _currentFile$metadata !== void 0 ? _currentFile$metadata : "",
                path: currentFile.path,
                uuid: currentFile.uuid
              };
            } else {
              (0, _DocumentGrid.getDocumentsWithChildren)([file.id], tree).filter(function (file) {
                return file.fileType !== _constants.TYPE_FOLDER;
              }).forEach(function (f) {
                var _f$metadata;
                var newPath = f.path.split("/").filter(function (path) {
                  return path !== "";
                }).map(function (path) {
                  return path === file.documentName ? currentFile.documentName : path;
                });
                // FileAlias is from Knowledge base, if not is Teams files
                attributes[f.fileAlias || f.uuid + "-" + f.documentName] = {
                  category: f.category,
                  metadata: (_f$metadata = f.metadata) !== null && _f$metadata !== void 0 ? _f$metadata : "",
                  path: newPath.join("/") + "/",
                  uuid: f.uuid
                };
              });
            }
            _context.prev = 3;
            url = "".concat(process.env.REACT_APP_SERVER_HOST, "/update");
            _context.next = 7;
            return _axios["default"].patch(url, {
              blobs: attributes,
              category_updated: file.fileType === _constants.TYPE_FOLDER ? false : currentFile.category !== file.category
            }, {
              headers: {
                "Cache-Control": "no-store"
              }
            });
          case 7:
            response = _context.sent;
            if (response.status == 200) {
              callbackClose(currentFile);
            }
            _context.next = 15;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](3);
            setAlertColor(_constants.AlertColor.Error);
            setAlertMessage(_context.t0.message || "Unexpected error while calling the reactor.");
          case 15:
            setIsLoading(false);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 11]]);
    }));
    return function editDocument() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    open: true,
    onClose: function onClose() {
      return callbackClose(null);
    },
    "data-testid": "modalEditFiles"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-kb-content",
    style: {
      height: "auto",
      width: "40vw",
      borderRadius: "4px"
    },
    "data-testid": "modal_edit"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-kb-header"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return callbackClose(null);
    },
    className: "close_icon"
  }, /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
    icon: "bitcoin-icons:cross-filled",
    height: 30,
    color: "#000000"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column",
    style: {
      gap: "15px"
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "modal-title",
    "data-testid": "edit-modal-title"
  }, "Edit ", type), /*#__PURE__*/_react["default"].createElement("span", null, "Edit the details for the following ", type, "."))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-kb-body flex flow-column gap-5",
    style: {
      marginTop: "5px",
      overflow: "auto"
    }
  }, file.fileType !== _constants.TYPE_FOLDER && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex gap-5"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, "File:")), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      width: "60%",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden"
    },
    title: currentFile.documentName
  }, currentFile.documentName)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex gap-5"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, "File Type:")), /*#__PURE__*/_react["default"].createElement("span", null, currentFile.fileType)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex gap-5"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, "Uploaded By:")), /*#__PURE__*/_react["default"].createElement("span", null, currentFile.uploadedBy)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex gap-5"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, "Uploaded Date:")), /*#__PURE__*/_react["default"].createElement("span", null, currentFile.uploaded))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column",
    style: {
      marginTop: "5px",
      gap: "24px"
    }
  }, file.fileType !== _constants.TYPE_FOLDER && /*#__PURE__*/_react["default"].createElement("span", {
    className: "modal-title"
  }, "Details"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex space-between"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Provide the ", type, " details."), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: "red"
    }
  }, "*"), "Indicates required"))), file.fileType !== _constants.TYPE_FOLDER && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column",
    style: {
      marginTop: "10px",
      rowGap: "20px"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: "red"
    }
  }, "*"), "File category"), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    select: true,
    label: "Select",
    name: "fileCategory",
    value: currentFile.category,
    onChange: function onChange(e) {
      setCurrentFile(_objectSpread(_objectSpread({}, currentFile), {}, {
        category: e.target.value
      }));
    },
    fullWidth: true,
    margin: "normal",
    variant: "outlined",
    size: "small",
    inputProps: {
      "data-testid": "categorySelector"
    }
  }, _constants.CATEGORIES.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
      key: option.value,
      value: option.value
    }, option.label);
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Metadata"), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    label: "Type",
    name: "metadata",
    value: currentFile.metadata,
    onChange: function onChange(e) {
      if (e.target.value.length <= _constants.MAX_METADATA_LENGTH) {
        setCurrentFile(_objectSpread(_objectSpread({}, currentFile), {}, {
          metadata: e.target.value
        }));
      }
    },
    fullWidth: true,
    multiline: true,
    rows: 3,
    inputProps: {
      "data-testid": "metadataField"
    },
    margin: "normal",
    variant: "outlined",
    placeholder: "Metadata improves AI search by adding context with keywords and descriptions, making search results more relevant and responses better."
  }), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "caption",
    display: "block",
    gutterBottom: true
  }, (_currentFile$metadata2 = currentFile.metadata) === null || _currentFile$metadata2 === void 0 ? void 0 : _currentFile$metadata2.length, " / ", _constants.MAX_METADATA_LENGTH))), file.fileType === _constants.TYPE_FOLDER && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column",
    style: {
      marginTop: "10px",
      rowGap: "20px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_CreateFolderStep["default"], {
    folderPath: currentFile.documentName,
    onChangeCallback: function onChangeCallback(e) {
      var value = e.target.value;
      if (!selectedPath) {
        return true;
      }
      // Lets validate if the folder exists
      var path = [].concat(_toConsumableArray(selectedPath), [{
        id: "constructed-".concat(value),
        name: value
      }]);

      // Navigate through the flat structure using parentId relationships
      var currentParentId = null;
      var folderExists = false;
      var _loop = function _loop() {
        var folderName = path[i].name.trim();

        // Find folder with matching name and correct parent
        var foundFolder = tree.find(function (doc) {
          return doc.documentName.trim() === folderName && doc.parentId === currentParentId && doc.fileType === _constants.TYPE_FOLDER;
        });
        if (foundFolder) {
          currentParentId = foundFolder.id;
          // If this is the last item in path and it's not the original folder name
          if (i === path.length - 1 && folderName !== file.documentName.trim()) {
            folderExists = true;
          }
        } else if (i < path.length - 1) {
          // If we can't find an intermediate folder, the path is invalid
          return 1; // break
        }
      };
      for (var i = 0; i < path.length; i++) {
        if (_loop()) break;
      }
      setIsDisabled(!value.trim() || folderExists);
      setCurrentFile(_objectSpread(_objectSpread({}, currentFile), {}, {
        documentName: value
      }));
      return folderExists;
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-kb-footer"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "save_btn",
    type: "submit",
    onClick: editDocument,
    disabled: isLoading || isDisabled,
    "data-testid": "editButton"
  }, isLoading ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      padding: "0 10px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
    size: 15
  }), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      marginLeft: 10
    }
  }, "Saving...")) : "Save"), /*#__PURE__*/_react["default"].createElement("button", {
    className: "cancel_btn",
    onClick: function onClick() {
      return callbackClose(null);
    },
    "data-testid": "cancelButton"
  }, "Cancel")))), /*#__PURE__*/_react["default"].createElement(_Alerts.Alerts, {
    style: {
      top: "90%",
      right: "unset",
      left: "unset"
    },
    alertOpen: alertMessage !== "",
    color: alertColor,
    message: alertMessage,
    handleAlertClose: function handleAlertClose() {
      return setAlertMessage("");
    }
  }));
};